enum ETokenSymbols {
  eth = 'eth',
  matic = 'matic',
  usdce = 'usdce',
  usdc = 'usdc'
}

export default ETokenSymbols